import React, { useCallback, useEffect, useRef, useState } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";


const localizer = momentLocalizer(moment);
const useStyles = makeStyles((theme) => ({
    root: {
        borderRight: `1px solid rgba(241,245,249,.12)`,

        "& .rbc-header": {
            padding: "12px 6px",
            fontWeight: 600,
            fontSize: 14,
        },
        "& .rbc-label": {
            padding: "8px 6px",
        },
        "& .rbc-today": {
            backgroundColor: "transparent",
        },
        "& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today": {
            borderBottom: `2px solid ${theme.palette.secondary.main}!important`,
            background: `${theme.palette.secondary.main}`,
        },
        "& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view": {
            padding: 24,
            [theme.breakpoints.down("sm")]: {
                padding: 16,
            },
            ...theme.mixins.border(0),
        },
        "& .rbc-agenda-view table": {
            ...theme.mixins.border(1),
            "& thead > tr > th": {
                ...theme.mixins.borderBottom(0),
            },
            "& tbody > tr > td": {
                padding: "12px 6px",
                "& + td": {
                    ...theme.mixins.borderLeft(1),
                },
            },
        },
        "& .rbc-time-view": {
            "& .rbc-time-header": {
                ...theme.mixins.border(1),
            },
            "& .rbc-time-content": {
                flex: "0 1 auto",
                ...theme.mixins.border(1),
            },
        },
        "& .rbc-month-view": {
            "& > .rbc-row": {
                ...theme.mixins.border(1),
            },
            "& .rbc-month-row": {
                ...theme.mixins.border(1),
                borderWidth: "0 1px 1px 1px!important",
                minHeight: 90,
            },
            "& .rbc-header + .rbc-header": {
                ...theme.mixins.borderLeft(1),
            },
            "& .rbc-header": {
                ...theme.mixins.borderBottom(0),
            },
            "& .rbc-day-bg + .rbc-day-bg": {
                ...theme.mixins.borderLeft(1),
            },
            "& .saturday": {
                background: `#2b3138`,
            },
            "& .sunday": {
                background: `#2b3138`,
            },
        },
        "& .rbc-day-slot .rbc-time-slot": {
            ...theme.mixins.borderTop(1),
            opacity: 0.5,
        },
        "& .rbc-time-header > .rbc-row > * + *": {
            ...theme.mixins.borderLeft(1),
        },
        "& .rbc-time-content > * + * > *": {
            ...theme.mixins.borderLeft(1),
        },
        "& .rbc-day-bg + .rbc-day-bg": {
            ...theme.mixins.borderLeft(1),
        },
        "& .rbc-time-header > .rbc-row:first-child": {
            ...theme.mixins.borderBottom(1),
        },
        "& .rbc-timeslot-group": {
            minHeight: 64,
            ...theme.mixins.borderBottom(1),
        },
        "& .rbc-date-cell": {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: 0.5,
            "& > a": {
                color: "inherit",
            },
        },
        "& .rbc-event": {
            borderRadius: 4,
            padding: "4px 8px",
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: "box-shadow",
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: "relative",
            "&:hover": {
                boxShadow: theme.shadows[2],
            },
        },
        "& .rbc-row-segment": {
            padding: "0 4px 4px 4px",
        },
        "& .rbc-off-range-bg": {
            backgroundColor:
                theme.palette.type === "light"
                    ? "rgba(0,0,0,0.03)"
                    : "rgba(0,0,0,0.16)",
        },
        "& .rbc-show-more": {
            color: theme.palette.secondary.main,
            background: "transparent",
        },
        "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event": {
            position: "static",
        },
        "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child":
        {
            left: 0,
            top: 0,
            bottom: 0,
            height: "auto",
        },
        "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child":
        {
            right: 0,
            top: 0,
            bottom: 0,
            height: "auto",
        },
    },
    addButton: {
        position: "absolute",
        right: 30,
        top: 135,
        zIndex: 99,
    },
}));
const LeaveCalendar = (props) => {

    // const leaveStartDate = moment().add(5, 'days');
    // const leaveEndDate = moment().add(12, 'days');

    const isLeaveDay = (date) => date.isBetween(leaveStartDate, leaveEndDate, null, '[]');
    const classes = useStyles(props);
    const [error, setError] = useState();
    const [leaveStartDate, setLeaveStartDate] = useState([]);
    const [leaveEndDate, setLeaveEndDate] = useState([]);
    const [leaveReason, setLeaveReason] = useState([]);
    const [department, setDepartment] = useState();
    const [currentEmp, setCurrentEmp] = useState();
    const [departmentOptions, setDepartmentOptions] = useState([
        { label: "Management", value: "Management" },
        { label: "Administration", value: "Administration" },
        { label: "Human Resources", value: "Human Resources" },
        { label: "Sales", value: "Sales" },
        { label: "Technical Division", value: "Technical Division" },
        { label: "Design Studio", value: "Design Studio" },
        { label: "Marketing", value: "Marketing" },
        { label: "Finance", value: "Finance" },
        { label: "Accounts", value: "Accounts" },
        { label: "Logistics", value: "Logistics" },
        { label: "Training", value: "Training" },
        { label: "IT", value: "IT" },
        { label: "Projects", value: "Projects" }
    ])

    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
    const navigate = useNavigate()
    const [leaveType, setLeaveType] = useState()
    const [view, setView] = useState(Views.MONTH);
    const [date, setDate] = useState(new Date());
    const [events, setEvents] = useState([]);
    const LeaveUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leave}`;
    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
    const handleChangeDepartment = (value) => {
        setDepartment(value.value)
        loadAllLeaveList()
    }

    const handleLeaveType = (data) => {
        setLeaveType(data.value)
        loadAllLeaveList()
    }

    const handlePrev = () => {
        const newDate = moment(date).subtract(1, 'months').toDate();
        setDate(newDate);
    };

    const handleNext = () => {
        const newDate = moment(date).add(1, 'months').toDate();
        setDate(newDate);
    };

    const handleToday = () => {
        setDate(new Date());
    };

    const handleViewChange = (selectedView) => {
        setView(selectedView);
    };

    useEffect(() => {
        const loadAllLeaveType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveCategories}`;
            try {
                const list = await OAuthService.getList(url);
                if (list?.data) {
                    const allCat = list?.data?._embedded?.leaveCategories.map((data) => {
                        return { label: data.category, value: data.category }
                    });
                    setLeaveTypeOptions(allCat)
                }
            } catch (error) {
            }
        }
        loadAllLeaveType()

        const getCurrentEmployee = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
            const email = token?.email;

            const emp = await OAuthService.getList(url + `/search/findEmployeeByEmail?email=${email}`);
            setCurrentEmp(emp?.data)
        }
        getCurrentEmployee();
    }, [])

    useEffect(() => {
        loadAllLeaveList();
    }, [leaveType, department, currentEmp])

    const loadAllLeaveList = async () => {
        try {
            let FilterData = {};
            if ((!token?.scope?.includes("ROLE_MD") && !token?.scope?.includes("ROLE_HR"))) {
                if (leaveType) {
                    FilterData = {...FilterData , leaveCategory: leaveType}
                }
                if(currentEmp?.employeeId){
                    FilterData = {...FilterData , empId: currentEmp?.employeeId}
                }
                if(department){
                    FilterData = {...FilterData , department: department}
                }
            }
            else {
                if (leaveType) {
                    FilterData = {...FilterData , leaveCategory: leaveType}
                }
                if(department){
                    FilterData = {...FilterData , department: department}
                }
            }
           

            const listData = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`,FilterData);
            if (listData?.data) {
                const leaveEvents = listData?.data?.map((data) => {
                    if ((!token?.scope?.includes("ROLE_MD") && !token?.scope?.includes("ROLE_HR"))) {
                        return {
                            title: data.employee.displayName + '  :  ' + data.leaveType.leaveCategory.category,
                            start: new Date(data.fromDate),
                            end: new Date(data.toDate),
                        };
                    } else {
                        return {
                            title: data.employee.displayName + '  :  ' + data.leaveType.leaveCategory.category +" , " + data.employee.department,
                            start: new Date(data.fromDate),
                            end: new Date(data.toDate),
                        };
                    }
                });
                setEvents(leaveEvents);
            }
            else {
                setEvents([])
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handleBack = () =>{
        navigate('/LeaveManagement')
    }

    const eventPropGetter = useCallback(
        (event, start, end, isSelected) => {
            const backgroundColor = isLeaveDay(moment(start)) ? '#FFA726' : '#419388'; // Customize the background color
            const style = {
                backgroundColor,
                borderRadius: '5px',
                color: 'white',
                border: '0px',
                display: 'block',
            };
            return { style };
        },
        [leaveStartDate, leaveEndDate]
    );

    const currentDate = moment(date).format("MMMM YYYY");

    const LeaveManagementFilter = () => {
        return <>
            {((token?.scope?.includes("ROLE_MD") || token?.scope?.includes("ROLE_HR"))) &&
                <Stack className="ml-10 mb-20">
                    <label className="pt-12  min-w-fit">Department</label>
                    <Select
                        name="department"
                        className=" min-w-[150px] h-[30px]"
                        value={(department && departmentOptions.length > 0) && departmentOptions.filter((list) => list.value === department)}
                        onChange={handleChangeDepartment}
                        options={departmentOptions}
                        styles={customStyles('', '', '0px')}
                    />
                </Stack>
            }

            <Stack className="ml-10 mb-20">
                <label className="pt-12 min-w-fit">Leave Type</label>
                < Select
                    name="leavetype"
                    className=" min-w-[150px] h-[30px]"
                    value={(leaveType && leaveTypeOptions.length > 0) && leaveTypeOptions.filter((data) => data.value === leaveType)}
                    onChange={handleLeaveType}
                    options={leaveTypeOptions}
                    styles={customStyles('', '', '0px')}
                />
            </Stack>
            <Tooltip title={"Back"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" , marginTop:"30px" }}
                                onClick={handleBack}
                            >
                                <FuseSvgIcon>material-outline:list</FuseSvgIcon>
                            </Button>
                        </Tooltip>
        </>
    }

    return (
        <>
            <ListPageHeader
                componentName="Leave Calendar"
                headerInputFields={LeaveManagementFilter()}
                pageName="Leave Calendar"
                showPaginationDropdown={false}
            />

            <div className={clsx(classes.root, "flex flex-col flex-auto relative")}>
                <div className="flex flex-col sm:flex-row  w-full items-center py-5 px-5 md:px-5 justify-between">
                    <div className=" flex text-24 font-extrabold tracking-tight" >
                        <Typography className="text-2xl mt-5">{currentDate}</Typography>
                        <Button size="small" onClick={handlePrev}> <FuseSvgIcon>material-outline:navigate_before</FuseSvgIcon></Button>
                        <Button size="small" onClick={handleNext}> <FuseSvgIcon>material-outline:navigate_next</FuseSvgIcon></Button>
                    </div>

                    <div className="flex justify-end" >
                        <Tooltip title="Today">
                            <Button onClick={handleToday}><FuseSvgIcon>material-outline:calendar_today</FuseSvgIcon></Button>
                        </Tooltip>
                        <Tooltip title="Day">
                            <Button onClick={() => handleViewChange(Views.DAY)}><FuseSvgIcon>material-outline:calendar_view_day</FuseSvgIcon></Button>
                        </Tooltip>
                        <Tooltip title="Week">
                            <Button onClick={() => handleViewChange(Views.WEEK)}><FuseSvgIcon>material-outline:calendar_view_week</FuseSvgIcon> </Button>
                        </Tooltip>

                        <Tooltip title="Month">
                            <Button onClick={() => handleViewChange(Views.MONTH)} ><FuseSvgIcon>material-outline:calendar_view_month</FuseSvgIcon></Button>
                        </Tooltip>
                    </div>

                </div>
                <Calendar
                    className="flex flex-1 container"
                    selectable
                    localizer={localizer}
                    events={events}
                    resizable
                    view={view}
                    onView={setView}
                    setView={setView}
                    date={date}
                    onNavigate={setDate}
                    defaultDate={new Date()}
                    startAccessor="start"
                    endAccessor="end"
                    setDate={setDate}
                    min={new Date()}
                    step={60}
                    showMultiDayTimes
                    toolbar={null}
                    eventPropGetter={eventPropGetter}

                />
            </div>
        </>
    )
}
export default LeaveCalendar
